const acceptButton = document.querySelector('.js-cookies-button-accept')
const cookieContainer = document.querySelector('.js-cookies-container')

cookieContainer.style.display = 'block'

acceptButton.addEventListener('click', function (event) {
  cookieContainer.style.display = 'none'
  event.preventDefault()
  submitPreference(true)
  const gtmScript = document.createElement('script')
  gtmScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-C35GGT2X1B')
  document.body.appendChild(gtmScript)
  const gaScript = document.createElement('script')
  gaScript.setAttribute('src', cookieContainer.dataset.gaUrl)
  document.body.appendChild(gaScript)
})

function submitPreference (accepted) {
  const xhr = new XMLHttpRequest()
  xhr.open('POST', '/cookies', true)
  xhr.setRequestHeader('Content-Type', 'application/json')
  xhr.send(JSON.stringify({
    crumb: document.querySelector('input[name="crumb"]').value,
    analytics: accepted,
    async: true,
  }))
}
